module.exports = __webpack_public_path__ + "static/media/monster-08.aeb5af0b.png";